export default "__VITE_ASSET__DogT99$8__"